import { useTranslation } from 'react-i18next';
import { alpha, styled } from '@mui/material/styles';
import { APPROVAL_PALETTE } from '@/theme/palette';

const Badge = styled('span')`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  padding: 1px 4px;
  margin-right: 4px;
  border-radius: 2px;
  background: ${alpha(APPROVAL_PALETTE.warning.main, 0.14)};
  color: ${APPROVAL_PALETTE.warning.dark};
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`;

/**
 * 휴직자 '휴직' 배지 — 결재 작성 화면 결재라인 행과 조회 화면 결재라인 카드에서 쓴다.
 * 퇴사 배지(DeactivatedBadge)와 같은 형태를 쓰되, 결재를 아예 못 하는 퇴사(적색)와
 * 지금 진행이 멈추는 휴직(주의색)을 색으로 구분한다.
 *
 * 휴직 종류 명칭(육아휴직 등)은 일부러 싣지 않는다 — 상신 판단에 필요한 정보는
 * '지금 결재가 진행되지 않는다' 는 사실이고, 종류는 결재라인을 보는 모든 작성자에게
 * 노출할 만한 정보가 아니다.
 */
const OnLeaveBadge = () => {
  const { t } = useTranslation();
  return <Badge>{t('휴직')}</Badge>;
};

export default OnLeaveBadge;
